var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5"},[_c('div',{staticClass:"nestable-draggable-parent-wrapper"},[_c('nested-draggable',{attrs:{"nests":_vm.nests}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('textarea',{staticClass:"d-none",attrs:{"name":"categories_nestable","id":"categories_nestable_hidden","hidden":""},domProps:{"value":_vm.processedCategoryTree}})])
}
var staticRenderFns = []

export { render, staticRenderFns }